import { FC } from 'react';
import styled from '@emotion/styled';
import { setTargetBlankToLinks } from 'src/utils/html';
const TermsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-block: 8px;
`;
const TermsText = styled.div`
  font-size: 10px;
  font-weight: 400;
  line-height: 13px;
  color: ${({
  theme
}) => theme.color.content10};
  margin: 0;

  b,
  strong {
    font-weight: 700;
  }

  a {
    font-weight: 700;
    text-decoration: underline;
    color: inherit;
    cursor: pointer;
  }
`;
interface Props {
  texts?: string[];
}
const SubscriptionTerms: FC<Props> = ({
  texts
}) => {
  if (!texts?.length) return null;
  return <TermsContainer data-sentry-element="TermsContainer" data-sentry-component="SubscriptionTerms" data-sentry-source-file="SubscriptionTerms.tsx">
      {texts.map((text, index) => <TermsText key={index} dangerouslySetInnerHTML={{
      __html: setTargetBlankToLinks(text)
    }} />)}
    </TermsContainer>;
};
export default SubscriptionTerms;